import { create } from "zustand";
import { persist } from "zustand/middleware";

interface RedirectProperty {
    id: string
    templateId?: string
}

interface RedirectRouteNotif {
    id: string
    templateId?: string
    setRedirectRouteNotif: (id: string, templateId?: string) => void
    getTemplateId: () => RedirectProperty | undefined
    clearRedirectRouteNotif: () => void
}

const useRedirectRouteNotif = create<RedirectRouteNotif>()(
    persist(
        (set, get) => ({
            id: '',
            templateId: '',
            setRedirectRouteNotif: (id: string, templateId?: string) => {
                set({ id, templateId })
            },
            getTemplateId: () => {
                const state = get();
                return {
                    id: state.id,
                    templateId: state.templateId
                }
            },
            clearRedirectRouteNotif: () => set({ id: '', templateId: '' }),
        }),
        {
            name: 'redirect-route-notif',
            getStorage: () => localStorage,
        }
    )
)

export default useRedirectRouteNotif